import SaleUtils from '@/services/SaleUtils'
//
export default [
  {
      text: "nombre",
      value: "name",
  },
  // {
  //     text: "dirección",
  //     value: "address",
  // },
  // {
  //     text: "Precio Compra",
  //     value: "cost_price",
  //     format: "currency",
  //     align: "right",
  //     input: {
  //         reverse: true,
  //         type: "currency-field",
  //         trigger:(ctx,props) =>{
  //           props.item.gains_margin = SaleUtils.getNewMargin(props.item.sale_price,props.item.cost_price)
  //         }
  //     },
  // },
  {
    text: "Precio Venta",
    value: "sale_price",
    format: "currency",
    align: "right",
    input: {
      reverse: true,
      disabled:true,
      type: "currency-field",
      trigger:(ctx,props) =>{
        //props.item.gains_margin = SaleUtils.getNewMargin(props.item.sale_price,props.item.cost_price)
      }
    },
  },
  {
    text: "Cantidad",
    value: "quantity_discount",
    align: "right",
    input: {
        reverse: true,
        type: "text-field"
    },
},
{
  text: "$ Descuento",
  value: "discount",
  align: "right",
  input: {
      reverse: true,
      disabled:true,
      type: "text-field",
      // trigger:(ctx,props) =>{
        
      //   props.item.new_price = props.item.sale_price-parseInt(props.item.unit_price_discount)
      //   ctx.$forceUpdate()
      // }
  },
},
{
  text: "Nuevo Precio",
  value: "unit_price_discount",
  format: "currency",
  align: "right",
  input: {
      reverse: true,
      
      type: "currency-field",
      trigger:(ctx,props) =>{
        
        props.item.discount = props.item.sale_price-parseInt(props.item.unit_price_discount)
        ctx.$forceUpdate()
      }
  },
},
  // {
  //   text: "Margen %",
  //   value: "gains_margin",
  //   align: "right",
  //   format: "percentage",
  //   // input: {
  //   //   reverse: true,
  //   //   //type: "text-field"
  //   // },
  // },
  // {
  //     text: "stock critico",
  //     value: "critical_stock",
  //     align: "right",
  //     input: {
  //         reverse: true,
  //         type: "text-field"
  //     },
  // },
]